import dayjs from 'dayjs';

const initialState: {
  items: any[];
  changeNumber?: number
} = {
  items: [],
  changeNumber: 0,
};

export enum libraryReducerActions {
  ADD_ITEM = 'ADD_ITEM',
  REMOVE_ITEM = 'REMOVE_ITEM',
  UPDATE_ITEM = 'UPDATE_ITEM',
  INIT_EMPTY = 'INIT_EMPTY',
  CHANGE_ALL = 'CHANGE_ALL',
  BATCH_DELETE = 'BATCH_DELETE', // 批量删除
}

export const LibraryListReducer = (state = initialState, action: {
  type: libraryReducerActions,
  payload?: {
    index?: number,
    keyIndex?: string,
    value?: any,
    append?: boolean,
    batchDelete?: {
      keyIndexs: string[]
    }
  }
}) => {
  const { items = [], changeNumber = 0 } = state;
  const { payload } = action || {};
  let index = payload?.index;
  let result = items;
  const keyIndexs = payload?.batchDelete?.keyIndexs || [];
  switch (action.type) {
    case libraryReducerActions.INIT_EMPTY:
      return {
        ...initialState,
      };

    case libraryReducerActions.CHANGE_ALL:
      return {
        ...state,
        changeNumber: changeNumber + 1,
        items: setKeyIndex(payload?.value),
      };

    case libraryReducerActions.ADD_ITEM:
      index = payload?.index === undefined ? items.length : payload?.index;
      result = items.slice(0, index).concat(payload?.value, items.slice(index)) || [];
      return {
        ...state,
        changeNumber: changeNumber + 1,
        items: setKeyIndex(result),
      };
    case libraryReducerActions.REMOVE_ITEM:
      result = items.filter(item => item?.keyIndex !== payload?.keyIndex) || [];
      return {
        ...state,
        items: setKeyIndex(result),
        changeNumber: changeNumber + 1,
      };
    case libraryReducerActions.BATCH_DELETE: // 批量删除
      if (keyIndexs.length) {
        result = items.filter(item => !keyIndexs.includes(item?.keyIndex)) || [];
      }
      return {
        ...state,
        items: setKeyIndex(result),
        changeNumber: changeNumber + 1,
      };

    case libraryReducerActions.UPDATE_ITEM:
      if (payload?.append) {
        result = [...payload?.value || [], ...state.items];
      } else {
        result = items.map(item => (item?.keyIndex === payload?.keyIndex ? payload?.value : item)) || [...state.items];
      }
      return {
        ...state,
        changeNumber: changeNumber + 1,
        items: setKeyIndex(result),
      };
    default:
      return state;
  }
};

export const setKeyIndex = (item: any[], init?: boolean) => item?.map((item, index) => {
  const random = dayjs().valueOf() + index;
  let keyIndex = item?.keyIndex !== undefined
    ? item?.keyIndex
    : `${random}_${index}`;

  if (init) {
    keyIndex = `${random}_${index}`;
  }
  return { ...item, keyIndex };
});

export default LibraryListReducer;
